(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  class CountdownBar extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.storageKey;
      try {
        if (this.key && sessionStorage.getItem(this.key) === 'closed') {
          this.remove();
          return;
        }
      } catch (e) {}

      this.endTime = (parseInt(this.dataset.endTs, 10) || 0) * 1000;
      this.hideOnExpiry = this.dataset.hideOnExpiry === 'true';
      this.hideDaysZero = this.dataset.hideDaysZero === 'true';

      this.elDays = this.querySelector('[data-days]');
      this.elHours = this.querySelector('[data-hours]');
      this.elMinutes = this.querySelector('[data-minutes]');
      this.elSeconds = this.querySelector('[data-seconds]');
      this.daysUnit = this.querySelector('[data-unit="days"]');
      this.daysSep = this.querySelector('[data-sep="days"]');

      const closeBtn = this.querySelector('[data-cb-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          try { if (this.key) sessionStorage.setItem(this.key, 'closed'); } catch (e) {}
          this.remove();
        });
      }

      if (!this.endTime || isNaN(this.endTime)) return;
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    pad(n) { return String(n).padStart(2, '0'); }

    tick() {
      const diff = this.endTime - Date.now();
      if (diff <= 0) {
        if (this.interval) clearInterval(this.interval);
        if (this.hideOnExpiry) { this.remove(); return; }
        [this.elDays, this.elHours, this.elMinutes, this.elSeconds].forEach((el) => { if (el) el.textContent = '00'; });
        return;
      }
      const total = Math.floor(diff / 1000);
      const days = Math.floor(total / 86400);
      const hours = Math.floor((total % 86400) / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;

      if (this.elDays) this.elDays.textContent = this.pad(days);
      if (this.elHours) this.elHours.textContent = this.pad(hours);
      if (this.elMinutes) this.elMinutes.textContent = this.pad(minutes);
      if (this.elSeconds) this.elSeconds.textContent = this.pad(seconds);

      const hideDays = this.hideDaysZero && days === 0;
      if (this.daysUnit) this.daysUnit.style.display = hideDays ? 'none' : '';
      if (this.daysSep) this.daysSep.style.display = hideDays ? 'none' : '';
    }
  }

  if (!customElements.get('countdown-bar')) {
    customElements.define('countdown-bar', CountdownBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
